// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../styles/_colors.css\"","off-white":"#f4f6f9","light-grey":"#9eabbc","dark-grey":"#475166","table":"SalesTable_table__1zLWs"};